const fr = {
  langName: "Français",
  locale: "fr_FR",
  meta: {
    home: ["Fondation MADE — Droits, santé et solidarité", "MADE ONLUS soutient les personnes en situation de vulnérabilité par l'assistance socio-sanitaire, la bienfaisance et la formation, en République dominicaine et en Italie."],
    about: ["Qui sommes-nous — Fondation MADE", "Histoire, mission et valeurs de la Fundación MADE : nous construisons les droits fondamentaux des personnes en mettant nos compétences à disposition."],
    activities: ["Nos activités — Fondation MADE", "Assistance socio-sanitaire, bienfaisance, éducation et formation, collaboration avec des professionnels de santé et soutien à des structures sociales."],
    projects: ["Projets — Fondation MADE", "Les projets documentés de MADE : La Romana en République dominicaine et Villa Bevilacqua Relais à Rapagnano, dans les Marches."],
    laRomana: ["Projet La Romana, République dominicaine — MADE", "Le projet socio-sanitaire de MADE à La Romana : un hôpital pour les plus démunis et, dans l'attente, une clinique mobile avec des spécialistes."],
    villa: ["Villa Bevilacqua Relais, Rapagnano (FM) — MADE", "Le projet Villa Bevilacqua Relais dans les Marches : plans, visualisations 3D et caractéristiques documentées de la structure."],
    team: ["L'équipe — Fondation MADE", "La Présidente, le Directeur médical et le personnel soignant de la Fundación MADE."],
    gallery: ["Galerie photo — Fondation MADE", "Photographies originales des personnes, des activités de santé, des collaborateurs et des projets de MADE."],
    donate: ["Faire un don — Soutenir MADE ONLUS", "Soutenez MADE par virement bancaire, par un don régulier via le mandat SDD ou en lui attribuant votre 5×1000."],
    contact: ["Contact — Fondation MADE", "Écrivez à MADE ONLUS : adresse, fax, e-mail et formulaire de contact."],
    privacy: ["Politique de confidentialité — MADE", "Informations sur le traitement des données personnelles collectées via le site de MADE ONLUS."],
    cookies: ["Politique en matière de cookies — MADE", "Informations sur les cookies et technologies similaires utilisés par le site de MADE ONLUS."],
    notFound: ["Page introuvable — MADE", "La page demandée n'existe pas."],
  },
  nav: { home: "Accueil", about: "Qui sommes-nous", activities: "Activités", projects: "Projets", team: "Équipe", gallery: "Galerie", donate: "Dons", contact: "Contact", donateNow: "Faire un don", menu: "Ouvrir le menu", close: "Fermer le menu", skip: "Aller au contenu", language: "Langue" },
  common: {
    discover: "En savoir plus",
    support: "Soutenir MADE",
    backToProjects: "Tous les projets",
    copy: "Copier",
    copied: "Copié dans le presse-papiers",
    viewAll: "Tout voir",
    requestInfo: "Demander des informations",
    source: "Source : documentation MADE",
    statusNote: "Les documents de la fondation présentent le projet et ses objectifs ; ils ne contiennent aucune information sur son achèvement ou sa mise en service.",
    projectGallery: "Galerie du projet",
    supportProject: "Soutenir ce projet",
    supportProjectText: "Vous pouvez indiquer le projet que vous souhaitez soutenir dans le motif du virement.",
  },
  home: {
    eyebrow: "Fundación MADE · MADE ONLUS",
    titleLines: ["Construisons", "ensemble un avenir", "meilleur."],
    subtitle: "Chaque geste de solidarité peut contribuer à protéger les droits fondamentaux des personnes et à soutenir celles et ceux qui en ont le plus besoin.",
    ctaMission: "Découvrir notre mission",
    ctaSupport: "Soutenir MADE",
    scroll: "Défiler",
    marquee: ["Assistance socio-sanitaire", "Bienfaisance", "Éducation", "Formation", "Droits fondamentaux", "La Romana", "Rapagnano"],
    aboutEyebrow: "Qui sommes-nous",
    aboutTitle: "Nous construisons les droits fondamentaux des personnes.",
    aboutText: "Nous soutenons, nous partageons, nous mettons nos compétences à disposition des situations de détresse que nous rencontrons et qui viennent à nous.",
    activitiesEyebrow: "Nos activités",
    activitiesTitle: "Soins, soutien et savoir pour celles et ceux qui vivent dans la pauvreté.",
    projectsEyebrow: "Projets à la une",
    projectsTitle: "Deux territoires, un seul engagement.",
    quote: "« Ton avenir dépend de ce que tu fais aujourd'hui, pas demain. »",
    teamEyebrow: "L'équipe",
    teamTitle: "Des personnes qui mettent leurs compétences au service des autres.",
    galleryEyebrow: "Galerie",
    galleryTitle: "Visages, gestes, lieux.",
    donateEyebrow: "Dons",
    donateTitle: "Votre soutien rend notre travail possible.",
    contactEyebrow: "Contact",
    contactTitle: "Vous souhaitez nous connaître, collaborer ou obtenir des informations ?",
    contactText: "Écrivez-nous : nous vous répondrons dans les meilleurs délais.",
  },
  about: {
    eyebrow: "Qui sommes-nous",
    titleLines: ["Qui est", "MADE"],
    intro: "Nous soutenons, nous partageons, nous mettons nos compétences à disposition des situations de détresse que nous rencontrons et qui viennent à nous.",
    motto: "Nous construisons les droits fondamentaux des personnes.",
    storyTitle: "Notre histoire",
    story: "La Présidente de la Fundación MADE est l'avocate Marzia Bevilacqua. Depuis toujours sensible aux questions sociales et animée par la volonté de protéger les droits des plus démunis, elle a créé la Fundación MADE après sa rencontre avec un groupe de médecins cubains à Saint-Domingue.",
    missionTitle: "Mission",
    mission: "Garantir l'assistance socio-sanitaire aux plus démunis et soutenir, par la bienfaisance, l'enseignement et la formation, les personnes qui vivent dans la pauvreté et l'exclusion.",
    visionTitle: "Vision",
    vision: "Un avenir où les droits fondamentaux de chaque personne sont protégés, à commencer par ce que nous choisissons de faire aujourd'hui.",
    valuesTitle: "Nos valeurs",
    values: [
      ["Soutien", "Nous sommes aux côtés des situations de détresse que nous rencontrons et qui viennent à nous."],
      ["Partage", "Nous partageons ressources, temps et expériences avec celles et ceux qui en ont le plus besoin."],
      ["Compétence", "Nous mettons à disposition des compétences professionnelles, à commencer par les compétences médicales."],
      ["Dignité", "Nous protégeons les droits fondamentaux de chaque personne."],
    ],
    italyTitle: "MADE ONLUS en Italie",
    italyText: "En Italie, la fondation agit sous le nom de MADE ONLUS, dont le siège se trouve Corso Cavour 86 à Macerata, et collecte des dons pour soutenir ses activités.",
  },
  activities: {
    eyebrow: "Activités",
    titleLines: ["Nos", "activités"],
    intro: "La Fundación MADE fonde ses activités sur l'assistance socio-sanitaire, la bienfaisance, l'enseignement et la formation des personnes vivant dans la pauvreté et l'exclusion, et contribue par ses dons à la construction de structures permettant de poursuivre son but social.",
    items: [
      ["Assistance socio-sanitaire", "Le but premier de la fondation est de garantir l'assistance socio-sanitaire aux plus démunis, notamment grâce à une clinique mobile capable d'atteindre les zones les plus inaccessibles de la République dominicaine."],
      ["Bienfaisance et soutien aux personnes vulnérables", "Nous soutenons les personnes qui vivent dans la pauvreté et l'exclusion en mettant à leur disposition des ressources et des compétences."],
      ["Éducation et formation", "L'enseignement et la formation sont les outils grâce auxquels nous offrons de nouvelles possibilités aux personnes que nous rencontrons."],
      ["Collaboration avec des professionnels de santé", "Le personnel médical et paramédical mis à disposition par MADE est composé d'une équipe de spécialistes d'origine cubaine."],
      ["Structures et initiatives sociales", "Nous contribuons par nos dons à la construction de structures permettant de poursuivre notre but social."],
    ],
    structures: ["Hôpitaux", "Puits", "Centres sociaux", "Écoles"],
    structuresNote: "Exemples de structures cités dans les documents de la fondation.",
  },
  projects: {
    eyebrow: "Projets",
    titleLines: ["Le", "projet"],
    intro: "Les projets présentés dans les documents de la fondation : une intervention socio-sanitaire en République dominicaine et une structure dans les Marches, en Italie.",
    objectivesTitle: "Objectifs documentés",
    laRomana: {
      name: "La Romana",
      place: "La Romana · République dominicaine",
      short: "La construction d'un hôpital pour garantir l'assistance socio-sanitaire aux plus démunis et, dans l'attente, une clinique mobile.",
      intro: "L'œuvre que la Fundación MADE entend réaliser, avec pour but premier de garantir l'assistance socio-sanitaire aux plus démunis, sera la construction d'un hôpital.",
      objectives: [
        "Construction d'un hôpital pour l'assistance socio-sanitaire des plus démunis.",
        "Utilisation, dans l'attente de la structure hospitalière, d'une clinique mobile capable d'atteindre même les zones les plus inaccessibles de la République dominicaine.",
        "Mise à disposition d'un personnel médical et paramédical spécialisé.",
      ],
      specialistsTitle: "Les spécialités de l'équipe médicale",
      specialistsText: "À ce jour, le personnel médical et paramédical mis à disposition par la Fundación MADE est composé d'une équipe de spécialistes, tous d'origine cubaine, en :",
      specialists: ["Orthopédie", "Urologie", "Gynécologie", "Médecine générale", "Médecine interne", "Anesthésiologie"],
    },
    villa: {
      name: "Villa Bevilacqua Relais",
      place: "Rapagnano (FM) · Marches · Italie",
      short: "Le projet d'une structure sur quatre niveaux, avec des espaces de soins à la personne, des cabinets médicaux, des chambres, des jardins suspendus et une crèche agricole avec animaux.",
      intro: "Le projet Villa Bevilacqua Relais, à Rapagnano dans la province de Fermo, est présenté dans la documentation par une vue aérienne du site, les plans de chaque étage et des visualisations 3D de la structure.",
      objectives: [
        "Une structure prévoyant une crèche agricole (agrinido) avec animaux, un espace d'accueil pour les animaux et une aire de jeux pour enfants.",
        "Au rez-de-chaussée : espaces de restauration, salle de sport, kinésithérapie, soins à la personne et cabinets médicaux.",
        "Module de 20/22 places avec la structure existante, avec des chambres au premier et au deuxième étage.",
      ],
      floorsTitle: "Les plans",
      floors: [
        ["Demi-sous-sol", "Cuisine (h 3,40 m), locaux du personnel, buanderie et chaufferie. Module de 20/22 places avec la structure existante (chambres au premier et au deuxième étage avec des exigences d'accréditation réduites).", "planSB"],
        ["Rez-de-chaussée", "Salle à manger 150 m², salle de sport 150 m², salle de loisirs 85 m², kinésithérapie 50 m², sanitaires 40 m², soins à la personne 65 m², salle de réunion 150 m², bureaux 50 m², accueil 60 m², cabinets médicaux et services 185 m².", "planGF"],
        ["Premier étage", "Huit chambres avec sanitaires, local du personnel et jardin suspendu. Surface disponible : 16 places en 8 chambres.", "planFF"],
        ["Deuxième étage (combles)", "Chambres, salle du personnel, sortie vers l'escalier de secours et jardin suspendu. Surface disponible : 6 places en 2 chambres, ou 4 places en 1 chambre avec salle du personnel.", "planSF"],
      ],
      renderTitle: "Visualisations 3D",
      renderText: "La structure prévoit une crèche agricole avec animaux, un espace d'accueil pour les animaux et une aire de jeux pour les enfants.",
      aerialTitle: "Le site",
      aerialText: "Vue aérienne du terrain de Villa Bevilacqua Relais à Rapagnano (FM).",
      elevationsTitle: "Élévations",
    },
  },
  team: {
    eyebrow: "Équipe",
    titleLines: ["L'équipe"],
    intro: "Les personnes présentées dans la brochure de la fondation et le personnel de santé mis à disposition par MADE.",
    presidentRole: "La Présidente",
    presidentName: "Me Marzia Bevilacqua",
    presidentBio: "Depuis toujours sensible aux questions sociales et animée par la volonté de protéger les droits des plus démunis, elle a créé la Fundación MADE après sa rencontre avec un groupe de médecins cubains à Saint-Domingue.",
    directorRole: "Le Directeur médical",
    directorName: "Dr Dennis Livan Gonzalez Martinez",
    directorBio: [
      "Diplômé en médecine et chirurgie de l'Institut supérieur des sciences médicales de La Havane, à Cuba, il se spécialise en orthopédie et traumatologie.",
      "Il travaille pendant plusieurs années dans les instituts pédiatriques les plus réputés de La Havane.",
      "En 2007, en mission humanitaire pour le compte du gouvernement cubain, il est envoyé en Haïti, où il prend en charge les victimes du terrible séisme de 2010.",
      "En 2012, il s'installe en République dominicaine. En 2015, il arrive en Italie.",
      "C'est autour de son expérience, de ses compétences et de son humanité que la Fundación MADE construit son action et lui en confie la direction opérationnelle.",
    ],
    staffTitle: "Personnel médical et collaborateurs",
    staffText: "Le personnel médical et paramédical de MADE est composé d'une équipe de spécialistes d'origine cubaine. Les photographies proviennent de la documentation de la fondation.",
  },
  gallery: {
    eyebrow: "Galerie",
    titleLines: ["Galerie", "photo"],
    intro: "Photographies originales issues de la documentation de la fondation.",
    all: "Toutes",
    cats: { people: "Personnes et communautés", health: "Activités de santé", volunteers: "Bénévoles et collaborateurs", projects: "Projets et structures", architecture: "Documentation architecturale" },
    close: "Fermer",
    prev: "Image précédente",
    next: "Image suivante",
    open: "Agrandir l'image",
    captions: {
      handsWater: "Mains et eau — image de couverture de la brochure MADE",
      smilingGirls: "Deux fillettes souriantes",
      girlBlue: "Une fillette au tee-shirt bleu",
      baby: "Un enfant dans les bras",
      twoChildren: "Deux enfants",
      childCap: "Un enfant à la casquette jaune, à l'hôpital",
      childBed: "Un jeune patient",
      drDennis: "Dr Dennis Livan Gonzalez Martinez, Directeur médical",
      doctors: "Médecins en blouse",
      staff: "Personnel de santé",
      teamShirts: "Le groupe MADE avec les tee-shirts de la fondation",
      volunteerChild: "Un collaborateur avec un enfant",
      volunteerElderly: "Une collaboratrice de MADE avec une personne âgée",
      selfie: "Une collaboratrice avec des enfants",
      kidsBanner: "Des enfants devant le logo MADE",
      drafting: "Le projet — La Romana, République dominicaine",
      aerial: "Villa Bevilacqua Relais — vue aérienne, Rapagnano (FM)",
      render3d: "Villa Bevilacqua Relais — visualisation 3D",
      agrinido: "Visualisation 3D : crèche agricole avec animaux et aire de jeux",
      planSB: "Plan — demi-sous-sol",
      planGF: "Plan — rez-de-chaussée",
      planFF: "Plan — premier étage",
      planSF: "Plan — deuxième étage (combles)",
      elevations: "Élévations de la structure",
    },
  },
  donate: {
    eyebrow: "Dons",
    titleLines: ["Faites un don", "à MADE Italie"],
    intro: "Aidez-nous à soutenir l'ONLUS MADE dans ses activités.",
    bankTitle: "Virement sur compte courant",
    ibanLabel: "IBAN",
    bankLabel: "Auprès de",
    holderLabel: "Titulaire",
    causalLabel: "Motif",
    causal: "Si vous souhaitez que votre don soutienne un projet précis, vous pouvez l'indiquer dans le motif du virement.",
    sddTitle: "Don régulier",
    sddText: "Les dons réguliers effectués au moyen du mandat SDD (ex-RID) prennent la forme d'un virement périodique par prélèvement automatique. Ils sont très importants pour nous : ils nous permettent de mieux programmer nos activités et de planifier nos initiatives et nos interventions à moyen et long terme.",
    sddThanks: "Merci de nous aider à faire connaître ce mode de soutien autour de vous.",
    sddHow: "Demandez le formulaire SDD, remplissez-le et renvoyez-le par fax ou par e-mail.",
    fiveTitle: "5×1000",
    fiveText: "Contribuables en Italie : si vous n'avez pas encore attribué votre 5×1000, voici notre code fiscal :",
    cfLabel: "Code fiscal",
    ctaInfo: "Demander des informations",
    ctaSdd: "Demander le formulaire SDD",
    noOnline: "Ce site ne collecte aucun paiement en ligne : les dons se font exclusivement par virement bancaire, mandat SDD ou 5×1000.",
    copyIban: "Copier l'IBAN",
    copyCf: "Copier le code fiscal",
  },
  contact: {
    eyebrow: "Contact",
    titleLines: ["Écrivez-nous"],
    intro: "Pour toute information, collaboration ou pour demander le formulaire de don régulier.",
    detailsTitle: "Coordonnées",
    addressLabel: "Adresse",
    faxLabel: "Fax",
    emailLabel: "E-mail",
    form: {
      title: "Formulaire de contact",
      name: "Nom et prénom",
      email: "E-mail",
      subject: "Objet",
      message: "Message",
      consent: "J'ai lu la politique de confidentialité et j'accepte le traitement de mes données afin de recevoir une réponse.",
      privacyLink: "Lire la politique de confidentialité",
      submit: "Envoyer le message",
      sending: "Envoi en cours…",
      success: "Merci ! Votre message a bien été envoyé. Nous vous répondrons dans les meilleurs délais.",
      error: "Une erreur s'est produite lors de l'envoi. Veuillez réessayer plus tard ou nous écrire par e-mail.",
      required: "Champ obligatoire",
      invalidEmail: "Veuillez saisir une adresse e-mail valide",
      consentRequired: "Vous devez accepter la politique de confidentialité",
      minMessage: "Le message doit contenir au moins 10 caractères",
      requiredNote: "Tous les champs sont obligatoires.",
    },
  },
  footer: {
    tagline: "Nous construisons les droits fondamentaux des personnes.",
    navTitle: "Navigation",
    contactTitle: "Contact",
    donateTitle: "Soutenez-nous",
    rights: "Tous droits réservés.",
    privacy: "Confidentialité",
    cookies: "Cookies",
    cookieSettings: "Préférences cookies",
    photos: "Photographies et images : documentation originale de MADE.",
  },
  cookie: {
    text: "Nous utilisons uniquement le stockage technique nécessaire au fonctionnement du site. Avec votre accord, la plateforme qui héberge le site peut collecter des statistiques d'utilisation.",
    accept: "Accepter",
    reject: "Nécessaires uniquement",
    more: "Politique cookies",
  },
  legal: {
    privacyTitle: "Politique de confidentialité",
    privacy: [
      ["Responsable du traitement", "MADE ONLUS, Corso Cavour 86 – 62100 Macerata (Italie). Code fiscal 93078840431. E-mail : madeonlus-italia@gmail.com."],
      ["Données collectées", "Le formulaire de contact recueille vos nom, adresse e-mail, objet et texte du message, ainsi que la langue du site et la date d'envoi."],
      ["Finalités et base juridique", "Les données sont traitées uniquement pour répondre à votre demande, sur la base de votre consentement (art. 6, par. 1, point a du Règlement (UE) 2016/679)."],
      ["Conservation", "Les données sont conservées le temps nécessaire au traitement de la demande et ne sont pas cédées à des tiers à des fins commerciales."],
      ["Vos droits", "Vous pouvez à tout moment demander l'accès, la rectification, l'effacement ou la limitation de vos données, retirer votre consentement et introduire une réclamation auprès de l'autorité de contrôle, en écrivant à l'adresse e-mail du responsable."],
    ],
    cookiesTitle: "Politique en matière de cookies",
    cookies: [
      ["Stockage technique", "Le site enregistre dans votre navigateur votre choix concernant les cookies. Cette information est nécessaire au fonctionnement du site et ne requiert pas de consentement."],
      ["Statistiques de la plateforme", "La plateforme qui héberge le site peut utiliser des outils de mesure d'audience. Ils ne sont activés que si vous acceptez via le bandeau ; en choisissant « Nécessaires uniquement », la collecte est désactivée."],
      ["Gestion des préférences", "Vous pouvez modifier votre choix à tout moment via le lien « Préférences cookies » en bas de page."],
    ],
  },
  notFound: { title: "Page introuvable", text: "La page que vous recherchez n'existe pas ou a été déplacée.", back: "Retour à l'accueil" },
};

export default fr;
